import { auditLogsReducer } from 'components/audit-logs/reducer';
import { connectionStatusReducer } from 'components/connection-status/reducer';
import { deviceRegistrationReducer } from 'pages/device-registration/reducer';
import { userGridReducer } from 'components/user-grid/reducer';
import { operationGridReducer } from 'components/operation-grid/reducer';
import { loginReducer } from 'pages/login/reducer';
import { mainReducer } from 'components/main/reducer';
import { menuReducer } from 'components/menu/reducer';
import { routerReducer } from 'react-router-redux';
import { scannerReducer } from 'components/scanner/reducer';
import { settingsReducer } from 'pages/settings/reducer';
import { userManagementReducer } from 'pages/user-management/reducer';
import { termsReducer } from 'pages/terms-of-use/reducer';
import { deviceInfoReducer } from 'pages/device-info/reducer';
import { notificationsReducer } from 'components/notification/reducer';
import { userProfileReducer } from 'pages/user-profile/reducer';

export const appReducers = {
  router: routerReducer,
  main: mainReducer,
  settings: settingsReducer,
  userGrid: userGridReducer,
  operationGrid: operationGridReducer,
  menu: menuReducer,
  connectionStatus: connectionStatusReducer,
  login: loginReducer,
  deviceRegistration: deviceRegistrationReducer,
  userManagement: userManagementReducer,
  auditLogs: auditLogsReducer,
  terms: termsReducer,
  scanner: scannerReducer,
  deviceInfo: deviceInfoReducer,
  userProfile: userProfileReducer,
  notifications: notificationsReducer
};


// WEBPACK FOOTER //
// ./src/pages/app/reducer.ts